import React from 'react';

const PauseButton: React.FC = () => (
  <svg viewBox="0 0 18 18" focusable="false">
    <rect x="5" width="2" height="18" rx="1" ry="1" />
    <rect x="11" width="2" height="18" rx="1" ry="1" />
  </svg>
);

export default PauseButton;
